import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "api/apiClient.ts";


interface Order {
  _id: string;
  products: Product[];
  total: number;
  paymentMethod: string;
  status: string;
  date: string;
  mosque: {
    _id: string;
    name: string;
  };
  customer: {
    _id: string;
    name: string;
  };
}

interface Product {
  _id: string;
  product: {
    _id: string;
    name: {
      ar: string;
      en: string;
    };
    category: {
      _id: string;
      name: {
        ar: string;
        en: string;
      };
    };
  };
  quantity: number;
}


// Fetch orders function
const fetchOrders = async (): Promise<Order[]> => {
  const { data } = await apiClient.get("/orders");
  if (data.status !== "success" || !Array.isArray(data.data.orders)) {
    throw new Error("Invalid response format");
  }
  
  return data.data.orders.map((order) => ({
    ...order,
    products: order.products.map((p) => ({
      ...p,
      product: p.product || { name: { en: "Unknown", ar: "غير معروف" } },
    })),
  }));
};

// Hook to get orders
export const useOrders = () => {
  return useQuery({
    queryKey: ["orders"],
    queryFn: fetchOrders,
  });
};
  
// Hook to update orders
export const useUpdateOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, orderStatus }: { id: string; orderStatus: string }) => {
      const response = await apiClient.patch(`/orders/update/${id}`, { orderStatus });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};
